<template>
    <li :class="classAttr" :to="item.path" disabled>
        <div :class="`nav-link nav-dropdown-toggle level-${item.level} theme-${item.theme}`" @click="handleClick">
            <FontAwesomeIcon v-if="item.icon" :icon="item.icon" fixed-width />
            <span class="dropdown-link-label">{{item.label}}</span>
        </div>
        <ul class="nav-dropdown-items">
            <template v-for="childItem in activeChildren">
                <template v-if="childItem.hasChildren">
                    <sidebar-nav-dropdown :key="childItem.clientKey" :item="childItem" />
                </template>
                <template v-else-if="!childItem.action">
                    <sidebar-nav-link :linkId="childItem.id" :key="childItem.clientKey" :item="childItem" />
                </template>
                <sidebar-nav-action v-else :linkId="childItem.id" :key="childItem.clientKey" :item="childItem" />
            </template>
        </ul>
    </li>
</template>

<script>
    import SidebarNavDropdown from './SidebarNavDropdown';
    import SidebarNavLink from './SidebarNavLink';
    import SidebarNavAction from './SidebarNavAction';
    export default {
        name:"SidebarNavDropdown",
        components: { SidebarNavDropdown, SidebarNavLink, SidebarNavAction },
        props: {
            item: { type: Object, required: true, default: () => {} },
            minimized: { type: Boolean, default: false }
        },
        data: function() {
            return {
                triggered: false,
                hasMatch: false
            }
        },
        computed: {
            classAttr() {
                let classes = ["nav-item", "nav-dropdown", `level-${this.item.level}`];
                if(this.item.children && this.hasChildMatch(this.item.children))
                {
                    classes.push("open active");
                }
                else {
                    if(this.$el && this.$el.classList.contains('open')){
                        classes.push("open");
                    }
                }

                return classes;
            },
            activeChildren() { return _.filter(this.item.children, item => !item.inactive); }
        },
        mounted() {
            this.triggered = true;
        },
        methods: {
            refreshVisibleMinimized() {
                if(this.item.visibleMinimized)
                    this.$el.classList.add("visible-minimized");
                else {
                    this.$el.classList.remove("visible-minimized");
                    this.collapse();
                }
            },

            collapse() {
                this.$el.classList.remove("open");
            },

            handleClick (e) {
                e.preventDefault();
                if(this.item.navigate && !this.$el.classList.contains("open")) {
                    this.$router.push(this.item.path);
                }
                if(this.minimized && this.item.level === 1) {
                    if(this.item.visibleMinimized) {
                        this.item.visibleMinimized = false;
                        this.refreshVisibleMinimized();
                        return;
                    }
                    this.$el.classList.add("open");
                    this.$emit("itemClick", { item: this.item });
                    return;
                }
                this.$el.classList.toggle('open');
            },

            hasChildMatch(list) {
                if(list) {
                    for (let x = 0; x < list.length; x++) {
                        if (list[x].children && list[x].children.length > 0) {
                            if(this.hasChildMatch(list[x].children)){
                                return true;
                            }
                        } else if (list[x].exactMatch || 
                            ((!_.isEmpty(list[x].name) && list[x].name === this.$route.name) 
                                || (!_.isEmpty(list[x].matchRoutePrefix) 
                                    && _.startsWith(this.$route.name, `${list[x].matchRoutePrefix}:`)))) {
                            return true;
                        }
                    }
                }
            }
        }
    };
</script>